import React, { useEffect } from "react";
import Container from "../hoc/Container";
import ShopCart from "../components/shop/shopCart";
import ShopRegionList from "../components/shop/shopRegionList";
import { useSelector } from "react-redux";
import { getOrderError } from "../store/order";
import { useModal } from "../hooks/useModal";
import NintendoInfo from "../components/shop/nintendoInfo";

function NintendoShop() {
  const error = useSelector(getOrderError());

  const { openModal } = useModal();
  useEffect(() => {
    if (error) openModal(error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  return (
    <Container>
      <section className="content-block mb-2">
          <h1 className="head-1">Карты Nintendo eShop</h1>
        <div className="shop-stack">
          <ShopRegionList shop={"eshop"} />
          <ShopCart shop={"eshop"} />
          <NintendoInfo />
        </div>
      </section>
    </Container>
  );
}

export default NintendoShop;
